<template>
  <div @click="showMore = id" style="position: relative">
    <span class="action-button float-right cursor-pointer showmore" v-bind:class="{ elipsisHighlight: showMore === id }">
      <font-awesome-icon class="mx-4" icon="ellipsis-v" />
    </span>
    <div class="dropdown-general align-middle font-weight-normal no-drag" v-on-clickaway="hideMenu" v-if="showMore === id">
      <div v-for="(item, key) in options" v-bind:key="key" :value="widget">
        <span
          v-if="item !== '|'"
          @click="submit(id, item)"
          v-bind:class="{
            'text-success': item === 'Resolve',
            'text-danger': item === 'Delete',
            'text-muted': lockOptions && lockOptions.includes(item.toLowerCase())
          }"
        >
          <font-awesome-icon
            v-if="item.toLowerCase().includes('download')"
            icon="download"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item.toLowerCase().includes('share')"
            icon="share"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Add a new variant'"
            icon="plus"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'API Key'"
            icon="code"
            class="mr-2"
          />          
          <font-awesome-icon
            v-if="item === 'Change goal'"
            icon="flag"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Reply'"
            icon="reply"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Save as video'"
            icon="download"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item.includes('Edit')"
            icon="edit"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Export data'"
            icon="download"
            class="mr-2"
          />          
          <font-awesome-icon
            v-if="item === 'Restart test'"
            icon="redo"
            class="mr-2"
          />          
          <font-awesome-icon
            v-if="item === 'End test now'"
            icon="stop"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Undo'"
            icon="undo"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Setting'"
            icon="cog"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Restart'"
            icon="redo"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Delete'"
            icon="trash"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Make a copy'"
            icon="copy"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Forward'"
            icon="share"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Resolve'"
            icon="check"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Advance setting'"
            icon="cog"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Targeting'"
            icon="star"
            class="mr-2"
          />
          <font-awesome-icon
            v-if="item === 'Trigger by JS'"
            icon="code"
            class="mr-2"
          />          
          {{ t(item) }}
          <div
            v-if="lockOptions && lockOptions.includes(item.toLowerCase())"
            class="badge badge-highlight ml-2"
            style="max-width: 60px;"
          >Pro plan</div>
        </span>
        <hr style="width: 100%" v-else class="dropdown-divider" />
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  props: ['id', 'options', 'data', 'lockOptions'],
  data: function () {
    return {
      showMore: null
    }
  },
  beforeMount() {
    if (this.$session.get('role') === 3) {
      for (let i = this.options.length - 1; i >= 0; i--) {
        if (this.options[i].toLowerCase().trim() === 'delete') {
          this.options.splice(i, 1)
        }
      }
    }
  },
  methods: {
    hideMenu() {
      setTimeout(() => {
        this.showMore = null
      }, 100)
    },
    submit(id, name) {
      this.hideMenu()
      let result = {
        id: id,
        name: name.toLowerCase()
      }
      if (this.data) result.data = this.data
      this.$emit('clicked', result)
    }
  }
}
</script>
<style>
.dropdown-general {
  position: absolute;
  background-color: var(--background);
  min-width: 220px;
  right: 0px;
  margin-top: 40px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  padding: 2px 0;
  text-align: left;
  z-index: 2000;
}

.dropdown-general span {
  color: var(--color);
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  cursor: pointer;
}

.dropdown-general span:hover {
  background-color: rgba(var(--main-color), 0.1);
}

.dropdown-general > hr {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

.dropdown-divider {
  background-color: #dbdbdb;
  border: none;
  display: block;
  height: 1px;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}

.action-button {
  margin: 0px;
  padding: 10px 0px;
  border-radius: 4px;
}

.action-button:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.elipsisHighlight {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>



// WEBPACK FOOTER //
// src/components/MoreOption.vue